import React from 'react'
import { TicketAmountsAndActionsProps } from './TicketStatusCard.types'
import TicketStatusBadge from './TicketStatusBadge'
import { FiEye, FiX } from 'react-icons/fi'
import { useTranslation } from 'react-i18next'
import { TicketStatus } from './TicketStatusBadge.types'
import styles from './TicketActionButton.module.css'

const TicketAmountsAndActions: React.FC<TicketAmountsAndActionsProps> = ({
  amount,
  winAmount,
  bonus,
  status,
  canCancel,
  onCancel,
  onViewClick,
  isPrimary,
}) => {
  const { t } = useTranslation()
  const shouldShowBonus =
    isPrimary && status === TicketStatus.SETTLED && bonus && bonus > 0

  return (
    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 sm:gap-0">
      {/* Amounts Group */}
      <div className="flex gap-0 sm:gap-6 justify-between sm:justify-start">
        <div className="flex flex-col items-center gap-2 sm:items-start w-auto">
          <div className="text-xs sm:text-sm text-center sm:text-left text-[var(--card-subtext)]">
            {t('pollItem.betAmount')}
          </div>
          <h5 className="font-semibold text-sm sm:text-base text-[var(--bet-type-hover-text)] whitespace-nowrap">
            {amount.toFixed(2)}
          </h5>
        </div>
        {shouldShowBonus && (
          <div className="flex flex-col items-center gap-2 sm:items-start w-auto">
            <div className="text-xs sm:text-sm text-center sm:text-left text-[var(--card-subtext)]">
              {t('pollItem.bonus')}
            </div>
            <h5 className="font-semibold text-sm sm:text-base text-[var(--bet-type-hover-text)] whitespace-nowrap">
              {bonus!.toFixed(2)}
            </h5>
          </div>
        )}
        <div className="flex flex-col items-center gap-2 sm:items-start w-auto">
          <div className="text-xs sm:text-sm text-center sm:text-left text-[var(--card-subtext)]">
            {t('pollItem.winAmount')}
          </div>
          <h5 className="font-medium text-sm sm:text-base text-[var(--bet-type-hover-text)] whitespace-nowrap">
            {winAmount.toFixed(2)}
          </h5>
        </div>
      </div>

      {/* Mobile divider before actions */}
      <hr className="sm:hidden border-t border-[var(--card-divider)]" />

      {/* Actions Group — items-stretch makes all columns equal height, mt-auto aligns icons at the bottom */}
      <div className="flex gap-3 sm:gap-6 sm:justify-end items-stretch">
        <div className="flex flex-col items-center mr-auto sm:mr-0">
          <div className="hidden text-sm sm:block text-center mb-1 text-[var(--card-subtext)]">
            {t('pollItem.status')}
          </div>
          <div className="relative top-1">
            <TicketStatusBadge status={status} />
          </div>
        </div>
        {canCancel && (
          <div className="flex flex-col items-center">
            <div className="hidden text-sm sm:block text-center mb-1 text-[var(--card-subtext)]">
              {t('pollItem.cancel')}
            </div>
            <div className="flex items-center justify-center mt-auto">
              {/* Mobile: Text */}
              <button
                className={`sm:hidden text-sm font-medium text-[var(--ticket-cancel-color)] bg-[var(--ticket-cancel-bg)] px-4 py-1.5 ${styles.actionBtn} cursor-pointer transition-opacity hover:opacity-80`}
                onClick={onCancel}
              >
                {t('pollItem.cancel')}
              </button>
              {/* Desktop: Icon */}
              <FiX
                className="hidden sm:block text-xl sm:text-2xl text-[var(--ticket-cancel-color)] cursor-pointer"
                onClick={onCancel}
              />
            </div>
          </div>
        )}
        <div className="flex flex-col items-center">
          <div className="hidden text-sm sm:block text-center mb-1 text-[var(--card-subtext)]">
            {t('pollItem.details')}
          </div>
          <div className="flex items-center justify-center mt-auto">
            {/* Mobile: Text */}
            <button
              className={`sm:hidden text-sm font-medium text-[var(--ticket-view-color)] bg-[var(--ticket-view-bg)] px-6 py-1.5 ${styles.actionBtn} cursor-pointer transition-opacity hover:opacity-80`}
              onClick={onViewClick}
            >
              {t('pollItem.view')}
            </button>
            {/* Desktop: Icon */}
            <FiEye
              className="hidden sm:block text-xl sm:text-2xl text-[var(--ticket-view-color)] cursor-pointer"
              onClick={onViewClick}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default TicketAmountsAndActions
